module.exports = __webpack_public_path__ + "img/banner_icon_4.62825253.png";